import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Wrapper from './Wrapper';

export default class PrivateRoute extends Component {
  constructor(props) {
    super(props);
    this.toast = React.createRef();
  }

  render() {
    const { component: Component, condition, ...rest } = this.props;

    return (
      <Route
        update={this.update}
        {...rest}
        render={(props) =>
          condition ? (
            <Wrapper isPrivateRoute={true} {...rest} {...props} component={Component} />
          ) : (
            <Redirect to={'/app/home'} />
          )
        }
      />
    );
  }
}
